import { ArrowUpDown } from "lucide-react";

import type { Column } from "@tanstack/react-table";

import { Button } from "../button";
import { useIsMobile } from "@/shared/hooks/useIsMobile";

interface DataTableSortedHeaderProps {
  title: string;
  column: Column<any, any>;
}

// TODO: удалить, есть SortButton

export const DataTableSortedHeader = ({
  title,
  column,
}: DataTableSortedHeaderProps) => {
  const sortColumn = () => column.toggleSorting(column.getIsSorted() === "asc");
  const isMobile = useIsMobile();

  return isMobile ? (
    title
  ) : (
    <Button variant="ghost" onClick={sortColumn}>
      {title}
      <ArrowUpDown className="ml-2 h-4 w-4" />
    </Button>
  );
};
